import useSWR from "swr";
import {
  listEmailIngestions,
  listFileShares,
  listSftpIngestions,
} from "../services/client-ingestion-service";
import {
  UseEmailIngestionsModel,
  UseFileSharesModel,
  UseSftpIngestionsModel,
} from "../types";

export const FILE_SHARES_KEY = "/ingestion/file-shares";

export const sftpIngestionsKey = (clientId: number) =>
  `/ingestion/sftp?clientId=${clientId}`;

export const emailIngestionsKey = (clientId: number) =>
  `/ingestion/email?clientId=${clientId}`;

export const useSftpIngestions = (
  clientId: number | null,
): UseSftpIngestionsModel => {
  const { data, error, isLoading, mutate } = useSWR(
    clientId !== null ? sftpIngestionsKey(clientId) : null,
    () => listSftpIngestions(clientId as number),
  );

  return { data, isLoading, error, mutate };
};

export const useEmailIngestions = (
  clientId: number | null,
): UseEmailIngestionsModel => {
  const { data, error, isLoading, mutate } = useSWR(
    clientId !== null ? emailIngestionsKey(clientId) : null,
    () => listEmailIngestions(clientId as number),
  );

  return { data, isLoading, error, mutate };
};

/** File shares are only needed while the email dialog is open. */
export const useFileShares = (enabled: boolean): UseFileSharesModel => {
  const { data, error, isLoading, mutate } = useSWR(
    enabled ? FILE_SHARES_KEY : null,
    listFileShares,
  );

  return { data, isLoading, error, mutate };
};
